import flow from 'lodash/flow';
import { AnalyticsSource } from '@atlassian/jira-analytics-web-react/src/components/decorators.tsx';
import withFireUiAnalytics from '@atlassian/jira-analytics-web-react/src/components/with-fire-ui-analytics.tsx';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import { MODAL } from '@atlassian/jira-product-analytics-bridge';
import Modal from './view.tsx';

export default flow(
	AnalyticsSource('managePagesLink', MODAL),
	withFireUiAnalytics({
		onClose: 'close',
	}),
	injectIntl,
)(Modal);
